import {Component, OnInit, OnDestroy, ViewChild, ElementRef} from '@angular/core';
import {BlogService} from '../../../core/services/blog.service';
import { MatSidenav } from '@angular/material/sidenav';
import {FuseConfigService} from '../../../core/services/config.service';
import {fromEvent as observableFromEvent, Subscription} from 'rxjs';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {MatPaginator} from '@angular/material/paginator';
import {PlatformsService} from '../../../core/services/platforms.service';
import {NgxSpinnerService} from 'ngx-spinner';

@Component({
    selector: 'blog-page',
    templateUrl: './blog.component.html',
    styleUrls: ['./blog.component.scss'],
    standalone: false
})
export class BlogComponent implements OnInit, OnDestroy {
  @ViewChild('filter', {static: true}) filter: ElementRef;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  _search = '';

  data;
  aboutBlocks = [];
  term;
  pageSize = 6;
  pageIndex = 0;
  totalCount = 0;
  @ViewChild('sidenav') sidenav: MatSidenav;
  public filterData: any = {};
  typesId = [];
  blogVisibility = '';
  isReadOnly = false;
  platformId = '';
  platforms = [];
  isSuperAdmin = false;
  public subscription = new Subscription();

  constructor(private blogService: BlogService, private fuseConfig: FuseConfigService,
              private platformsService: PlatformsService, private spinner: NgxSpinnerService) {
    this.subscription.add(this.fuseConfig.role.subscribe(res => {
      this.isReadOnly = res && res === 'readOnly';
      this.isSuperAdmin = res && res === 'superAdmin';
    }));
    this.subscription.add(this.fuseConfig.selectedPlatform.subscribe(res => {
      if (res && res.id) {
        this.platformId = res.id;
        this.getBlogs();
      }
    }));
  }

  ngOnInit() {
    this.getBlogs();
    this.getBlogTypes();
    this.filterData.blobVisibility = true;
    this._search = localStorage.getItem('eventSearch') ? localStorage.getItem('eventSearch') : '';
    if (this._search && this._search !== 'null') {
      this.filter.nativeElement.value = this._search;
    }
    this.subscription.add(observableFromEvent(this.filter.nativeElement , 'keyup').pipe(
      debounceTime(1500) ,
      distinctUntilChanged())
      .subscribe(() => {
        if (this.filter.nativeElement.value && this.filter.nativeElement.value.replace(/ /g, '')
          && this.filter.nativeElement.value !== null && this.filter.nativeElement.value !== 'null') {
          this._search = this.filter.nativeElement.value;
          localStorage.setItem('blogSearch', this.filter.nativeElement.value);
          this.paginator.firstPage();
          this.getBlogs();
        } else if ((!this.filter.nativeElement.value || this.filter.nativeElement.value === '') && this._search){
          this._search = '';
          localStorage.setItem('blogSearch', this.filter.nativeElement.value);
          this.paginator.firstPage();
          this.getBlogs();
        }
      }));
    if (this.isSuperAdmin) {
      this.getPlatforms();
    }
  }

  getPlatforms() {
    this.platformsService.getPlatforms().subscribe((res: any) => {
      if (res && res.length) {
        this.platforms = res;
        this.filterData.platforms = res;
      }
    });
  }

  getBlogs() {
    this.spinner.show();
    this.blogService.getBlogs(this.pageIndex + 1, this.pageSize, this.typesId,
      this.blogVisibility, this.platformId, this._search, this.isSuperAdmin).subscribe((res: any) => {
      this.aboutBlocks = res.blogs;
      this.totalCount = res.length;
      this.spinner.hide();
    });
  }

  getBlogTypes() {
    this.blogService.getBlogTypes().subscribe((res: any) => {
      this.filterData.blogTypes = res;
    });
  }

  changePageEmitter(e) {
    this.pageIndex = e.pageIndex;
    this.pageSize = e.pageSize;
    this.getBlogs();
  }

  chooseFilters (e) {
    this.pageIndex = 0;
    if (e.choose === 'all') {
      delete this.filterData.blogTypes;
      delete this.filterData.blobVisibility;
      this.typesId = [];
      this.blogVisibility = '';
      this.getBlogs();
      this.getBlogTypes();
      setTimeout(() => {
        this.filterData.blobVisibility = true;
      });
    } else if (e.choose.hasOwnProperty('tag')) {
      if (e.choose.selected) {
        this.typesId.push(e.choose.tag);
      } else {
        const index = this.typesId.indexOf(e.choose.tag);
        if (index !== -1) {
          this.typesId.splice(index , 1);
        }
      }
      this.getBlogs();
    } else if (e.choose.hasOwnProperty('publicBlogs')) {
      this.blogVisibility = e.choose.publicBlogs;
      this.getBlogs();
    } else if (e.choose.hasOwnProperty('platforms')) {
      this.platformId = e.choose.platforms;
      this.getBlogs();
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
